import React from "react";
import { formatDateTime } from "../model/suiviLivraisonFormat";
import { actionTimeline, destinationComments, productionComments } from "../model/suiviLivraisonRules";

// Actions réalisées sur un produit, commentaires de production et commentaires de planification d'un flux.

export function ActionTimeline({ row }) {
    const actions = actionTimeline(row);
    if (actions.length === 0) {
        return <span style={{ color: "#cbd5e1", fontSize: "11px" }}>—</span>;
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px", whiteSpace: "normal" }}>
            {actions.map(action => (
                <div key={action.label} style={{ lineHeight: 1.25 }}>
                    <span style={{ color: "#475569", fontWeight: 700, fontSize: "11px" }}>{action.label}</span>
                    <div style={{ color: "#64748b", fontSize: "11px" }}>
                        {formatDateTime(action.at) || "heure non renseignée"}
                        {action.by && <span style={{ color: "#334155" }}> · {action.by}</span>}
                    </div>
                </div>
            ))}
        </div>
    );
}

const productionCommentStyle = {
    padding: "6px 8px",
    borderRadius: "6px",
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    color: "#475569",
    fontSize: "11.5px",
    lineHeight: 1.35,
    wordBreak: "break-word",
};

export function ProductionComments({ row }) {
    const comments = productionComments(row);
    if (comments.length === 0) return null;

    return (
        <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", gap: "4px", whiteSpace: "normal" }}>
            {comments.map(([label, value]) => (
                <div key={`${label}:${value}`} style={productionCommentStyle}>
                    <strong style={{ color: "#334155" }}>{label}</strong> · {value}
                </div>
            ))}
        </div>
    );
}

function destinationCommentStyle(robot) {
    return {
        padding: "6px 8px",
        borderRadius: "6px",
        background: robot ? "#f5f3ff" : "#ecfeff",
        border: `1px solid ${robot ? "#ddd6fe" : "#a5f3fc"}`,
        color: "#334155",
        fontSize: "11px",
        lineHeight: 1.35,
        wordBreak: "break-word",
    };
}

export function DestinationMedicationComments({ destination, rows }) {
    const { label, comments } = destinationComments(destination, rows);
    if (comments.length === 0) return null;
    const robot = label === "Robot";

    return (
        <div style={{ marginTop: "8px", display: "grid", gap: "6px", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))" }}>
            {comments.map(value => (
                <div key={value} style={destinationCommentStyle(robot)}>
                    <strong style={{ color: robot ? "#5b21b6" : "#0e7490" }}>Commentaire {label.toLowerCase()}</strong>
                    <div>{value}</div>
                </div>
            ))}
        </div>
    );
}
